"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KitchenSinkModule = void 0;
const router_1 = require("client/components/router");
const React = require("react");
const alerts_1 = require("./alerts");
const barcodes_1 = require("./barcodes");
const buttons_1 = require("./buttons");
const checkboxes_1 = require("./checkboxes");
const group_list_1 = require("./group-list");
const icons_1 = require("./icons");
const kpis_1 = require("./kpis");
const lists_1 = require("./lists");
const menus_1 = require("./menus");
const modals_1 = require("./modals");
const selects_1 = require("./selects");
const signature_pad_1 = require("./signature-pad");
const styles_1 = require("./styles");
const swatches_1 = require("./swatches");
const text_fields_1 = require("./text-fields");
const title_bars_1 = require("./title-bars");
const group_management_modal_1 = require("../inventory/modules/inventory-detail/components/edit-inventory/group-management-modal");
require("./kitchen-sink.less");
class KitchenSinkModule extends router_1.TabRouter {
    constructor(props) {
        super(props);
        this.addTab("General", "/sink", /^\/(kitchen-)?sink\/?$/, () => (React.createElement("div", null,
            React.createElement(swatches_1.SwatchesSink, null),
            React.createElement(icons_1.IconsSink, null),
            React.createElement(styles_1.StylesSink, null))));
        this.addTab("Form", "/sink/form", /^\/(kitchen-)?sink\/form\/?$/, () => (React.createElement("div", null,
            React.createElement(buttons_1.ButtonsSink, null),
            React.createElement(text_fields_1.TextFieldsSink, null),
            React.createElement(selects_1.SelectsSink, null),
            React.createElement(barcodes_1.BarcodesSink, null),
            React.createElement(checkboxes_1.CheckboxesSink, null),
            React.createElement(signature_pad_1.SignaturePadSink, null))));
        this.addTab("UI", "/sink/ui", /^\/(kitchen-)?sink\/ui\/?$/, () => (React.createElement("div", null,
            React.createElement(title_bars_1.TitleBarsSink, null),
            React.createElement(menus_1.MenusSink, null),
            React.createElement(alerts_1.AlertsSink, null),
            React.createElement(modals_1.ModalsSink, null),
            React.createElement(group_management_modal_1.GroupManagementModal, null))));
        this.addTab("Lists", "/sink/lists", /^\/(kitchen-)?sink\/lists\/?$/, () => (React.createElement("div", null,
            React.createElement(lists_1.ListsSink, null),
            React.createElement(group_list_1.GroupListSink, null))));
        this.addTab("Miscellaneous", "/sink/misc", /^\/(kitchen-)?sink\/misc\/?$/, () => (React.createElement("div", null,
            React.createElement(kpis_1.KpisSink, null))));
    }
    render() {
        return (React.createElement("div", { className: "kitchen-sink" },
            React.createElement("h1", null, "Kitchen Sink"),
            React.createElement("p", null, "This is a kitchen sink page where we dump random components to test them out"),
            super.render()));
    }
}
exports.KitchenSinkModule = KitchenSinkModule;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/kitchen-sink/kitchen-sink.tsx
// module id = 3608
// module chunks = 0